import { render, staticRenderFns } from "./ColletionsCatalog.vue?vue&type=template&id=502c5b59"
import script from "./ColletionsCatalog.vue?vue&type=script&lang=js"
export * from "./ColletionsCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports